import type { Due } from '@/entities/shared/due/due';
import { dueState } from '@/entities/shared/due/due-state';
import { REMIND_DAYS } from '@/entities/shared/due/remind-days';
import { daysBetween } from '@/shared/lib/dates/days-between';
import type { IsoDate } from '@/shared/lib/dates/iso-date';
import { today } from '@/shared/lib/dates/today';
import type { KitDocument } from '../schemas/kit-document';

/** Documents warn 90 days ahead by default (renewing a passport takes time), or as they say. */
export function documentDue(doc: KitDocument, on: IsoDate = today()): Due | null {
  if (!doc.expires_on) return null;
  const days = daysBetween(on, doc.expires_on);
  const urgency = dueState(days, doc.remind_days ?? REMIND_DAYS.document);
  return { date: doc.expires_on, kind: 'expires', days, urgency };
}
